export default "__VITE_ASSET__e5423a18__"